import { createAPICall } from "src/api";
import { OrgSerializer, UserOrgsSerializer } from "src/serializers";
import { omitUndefined } from "src/utils";

const url = "/api/v1/orgs/sso-orgs";
const orgsListUrl = "/api/v1/orgs/orgs";
const orgsMonitoringListUrl = "/api/v1/monitoring/orgs";
const orgSwitchUrl = (orgId) => `/api/v1/orgs/orgs/${orgId}/switch`;
const serializer = OrgSerializer;

const OrgAPI = {
  fetchOrgs: ({ orgIdentifier }) =>
    createAPICall({
      url,
      queryParams: omitUndefined({ short_name: orgIdentifier }),
      serializer,
    }),
  fetchOrgsForMonitoring: (domain = null) =>
    createAPICall({
      url: domain ? `${domain}${orgsMonitoringListUrl}` : orgsMonitoringListUrl,
      queryParams: { token: window.Settings.activeClassToken },
      serializer,
    }),
  fetchOrgsForUser: () =>
    createAPICall({
      url: orgsListUrl,
      serializer: UserOrgsSerializer,
    }),
  switchUserOrg: (orgId) =>
    createAPICall({
      url: orgSwitchUrl(orgId),
      method: "POST",
      serializer: UserOrgsSerializer,
    }),
};

export { OrgAPI };
